module.exports = __webpack_public_path__ + "public/images/history.ae79f8ee9c3f32342732ce67bfb76047.png";